// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"10599f64541fb2cc2ee8","293":"d3834f52efc2815bb8e1","518":"07ed65d778c96c58acf6","779":"5e9525f4f6ba2429a5e2"}[chunkId] + ".js";
};